import isMobile from '@/utils/checkMobile';
import { Box, Dialog } from '@mui/material';
import ChatTestIframe from './ChatTestIframe';
import { RebuildState } from '@/store/spaceHomeRebuildStore';
import { useEffect } from 'react';

interface ChatDialogPropType {
    open: boolean;
    setOpen: Function;
    designData?: RebuildState;
    chatTargetId?: string;
}
export default function ChatDialog(props: Readonly<ChatDialogPropType>) {
    const { open, setOpen, chatTargetId } = props;
    const checkMobile = isMobile();
    useEffect(() => {
        window.addEventListener('message', (event) => {
            if (event?.origin) {
                if (event?.data == 'close') setOpen(false);
            }
        });
    }, []);
    return (
        <Dialog
            open={open}
            fullScreen={checkMobile}
            onClose={() => {
                setOpen(false);
            }}
            sx={checkMobile ? {} : { paddingBottom: '4rem' }}
            PaperProps={
                checkMobile
                    ? {}
                    : { sx: { borderRadius: '1.875rem', position: 'absolute', right: '0', bottom: '8rem' } }
            }
            hideBackdrop={true}
        >
            {checkMobile && <ChatTestIframe setOpen={setOpen} targetId={chatTargetId || ''} />}
            {!checkMobile && (
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        height: '74vh',
                        maxHeight: '52.875rem',
                    }}
                >
                    <Box
                        sx={{
                            height: '100%',
                            width: '24.4375rem',
                            overflow: 'hidden',
                        }}
                    >
                        <ChatTestIframe setOpen={setOpen} targetId={chatTargetId || ''} />
                    </Box>
                </Box>
            )}
        </Dialog>
    );
}
